export default {"src":"/_next/static/media/aboutUs1.ca67f989.svg","height":1386,"width":1300};